import { Box, Button, Heading, Page } from '@zillow/constellation-10';
import { IconPlusCircleFilled } from '@zillow/constellation-icons';

import accessUtils from '../../../../srcLegacy/shared/utils/accessUtils';
import { useScreenSize } from '../../../hooks/useScreenSize';

import { EVENT_IDS } from '../../../analytics/events/addPropertyModal';

import { useAuth } from '../../../components/AuthProvider';

type Props = {
  handleAddPropertyClick: () => void;
  handleAddFeedListingsClick: () => void;
};

export const PageHeading = ({ handleAddPropertyClick, handleAddFeedListingsClick }: Props) => {
  const { user } = useAuth();
  const { isScreenMobile } = useScreenSize();

  const showAddPropertyButton = user?.features?.canAddListing ?? false;
  const canAccessAddFeedListingsModal = accessUtils.canAccessAddFeedListingsModal({ user });
  const showButtonsNextRow = isScreenMobile && showAddPropertyButton && canAccessAddFeedListingsModal;

  const pageTitle = 'Properties';

  const renderAddButtons = () => (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: '600',
      }}
    >
      {showAddPropertyButton && (
        <Button
          tone="brand"
          emphasis="outlined"
          onClick={handleAddPropertyClick}
          data-testid="AddPropertyButton"
          data-eventid={EVENT_IDS.OPEN}
          data-eventdescription="View add property modal"
          icon={<IconPlusCircleFilled />}
          iconPosition="end"
        >
          Add a property
        </Button>
      )}
      {canAccessAddFeedListingsModal && (
        <Button
          tone="brand"
          emphasis="outlined"
          onClick={handleAddFeedListingsClick}
          data-eventid={EVENT_IDS.ADD_FEED_CLICK}
          data-eventdescription="View add feed modal"
          icon={<IconPlusCircleFilled />}
          iconPosition="end"
        >
          Add feed
        </Button>
      )}
    </Box>
  );

  return (
    <Page.Content css={{ marginBottom: '400' }}>
      {!showButtonsNextRow && (
        <Box css={{ display: 'flex', alignItems: 'center' }}>
          <Box css={{ flex: '1' }}>
            <Heading level={1} textStyle="heading-md">
              {pageTitle}
            </Heading>
          </Box>
          <Box css={{ paddingLeft: '400' }}>{renderAddButtons()}</Box>
        </Box>
      )}
      {showButtonsNextRow && (
        <Box>
          <Heading level={1} textStyle="heading-md">
            {pageTitle}
          </Heading>
          <Box css={{ paddingTop: '400' }}>{renderAddButtons()}</Box>
        </Box>
      )}
    </Page.Content>
  );
};
